// src/contexts/LanguageContext.jsx
import React, { createContext, useContext, useState, useEffect, useRef } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'en';
  });
  const [translations, setTranslations] = useState({});
  const cacheRef = useRef({});

  const loadLanguage = async (lang) => {
    if (cacheRef.current[lang]) {
      setTranslations(cacheRef.current[lang]);
      return;
    }
    try {
      const response = await fetch(`/locales/${lang}.json`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      cacheRef.current[lang] = data;
      setTranslations(data);
    } catch (error) {
      console.error("Translation file not found or invalid JSON:", error);
      setTranslations({});
    }
  };

  useEffect(() => {
    loadLanguage(language);

    // Preload alternate language in background for instant switching
    const otherLang = language === "en" ? "de" : "en";
    fetch(`/locales/${otherLang}.json`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data) cacheRef.current[otherLang] = data;
      })
      .catch(() => { });
  }, []);

  const toggleLanguage = () => {
    const newLanguage = language === "en" ? "de" : "en";
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
    loadLanguage(newLanguage);
  };

  return (
    <LanguageContext.Provider
      value={{ language, toggleLanguage, translations }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
